/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCarePatient
 */
export interface MatrixCarePatient {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    gender?: MatrixCarePatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    date_of_birth?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    medical_record_number?: string;
    /**
     *
     * @type {string}
     * @memberof MatrixCarePatient
     */
    race_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    religion?: MatrixCarePatientReligionEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    marital_status?: MatrixCarePatientMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    primary_medicare_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    primary_medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    secondary_medicare_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatient
     */
    payer?: string;
}


/**
 * @export
 */
export const MatrixCarePatientGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;
export type MatrixCarePatientGenderEnum = typeof MatrixCarePatientGenderEnum[keyof typeof MatrixCarePatientGenderEnum];

/**
 * @export
 */
export const MatrixCarePatientReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown'
} as const;
export type MatrixCarePatientReligionEnum = typeof MatrixCarePatientReligionEnum[keyof typeof MatrixCarePatientReligionEnum];

/**
 * @export
 */
export const MatrixCarePatientMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined'
} as const;
export type MatrixCarePatientMaritalStatusEnum = typeof MatrixCarePatientMaritalStatusEnum[keyof typeof MatrixCarePatientMaritalStatusEnum];


/**
 * Check if a given object implements the MatrixCarePatient interface.
 */
export function instanceOfMatrixCarePatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientFromJSON(json: any): MatrixCarePatient {
    return MatrixCarePatientFromJSONTyped(json, false);
}

export function MatrixCarePatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'middle_name': !exists(json, 'middle_name') ? undefined : json['middle_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'date_of_birth': !exists(json, 'date_of_birth') ? undefined : json['date_of_birth'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'medical_record_number': !exists(json, 'medical_record_number') ? undefined : json['medical_record_number'],
        'race_id': !exists(json, 'race_id') ? undefined : json['race_id'],
        'religion': !exists(json, 'religion') ? undefined : json['religion'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'primary_medicare_number': !exists(json, 'primary_medicare_number') ? undefined : json['primary_medicare_number'],
        'primary_medicaid_number': !exists(json, 'primary_medicaid_number') ? undefined : json['primary_medicaid_number'],
        'secondary_medicare_number': !exists(json, 'secondary_medicare_number') ? undefined : json['secondary_medicare_number'],
        'payer': !exists(json, 'payer') ? undefined : json['payer'],
    };
}

export function MatrixCarePatientToJSON(value?: MatrixCarePatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'middle_name': value.middle_name,
        'last_name': value.last_name,
        'gender': value.gender,
        'date_of_birth': value.date_of_birth,
        'phone_number': value.phone_number,
        'ssn': value.ssn,
        'medical_record_number': value.medical_record_number,
        'race_id': value.race_id,
        'religion': value.religion,
        'marital_status': value.marital_status,
        'language': value.language,
        'address': value.address,
        'state_id': value.state_id,
        'primary_medicare_number': value.primary_medicare_number,
        'primary_medicaid_number': value.primary_medicaid_number,
        'secondary_medicare_number': value.secondary_medicare_number,
        'payer': value.payer,
    };
}
